export const isWebView = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const iosWebView = /(iphone|ipod|ipad).*applewebkit(?!.*version)/.test(userAgent);
  
    if (iosWebView) {
      return true;
    } else if (userAgent.includes('wv')) {
      return true;
    }
    
    return false;
  }